
import { AdminAudit } from '@/screens'

export default meta => [{
    path: 'audit',
    name: 'AdminAudit',
    component: AdminAudit,
    meta,
}]
